import {
  DEFAULT_DISTRIBUTION_PARTNER_NUMBER,
  DISTRIBUTION_PARTNER_TYPE_OFFERTE,
  DISTRIBUTION_PARTNER_TYPES,
} from '@/config/constants'

export const DistributionUtil = {
  /**
   * Baskets created in dvp have the same distributionPartnerNumber for all types
   *
   * @param distributionPartnerNumber
   * @returns {{distributionPartnerNumber: *, distributionPartnerType: *}[]}
   */
  createDistributionPartners(distributionPartnerNumber) {
    return DISTRIBUTION_PARTNER_TYPES.map(type => createDistributionPartner(distributionPartnerNumber, type))
  },

  getDistributionPartnerNumber(distributionPartners, type) {
    if (!distributionPartners) throw new Error('distributionPartners missing from basket')

    const partner = distributionPartners.find(p => p.distributionPartnerType === type)
    return partner?.distributionPartnerNumber
  },

  // TODO: remove this function and add default type to getDistributionPartnerNumber
  getDistributionPartnerByBasket(basket, type = DISTRIBUTION_PARTNER_TYPE_OFFERTE) {
    return this.getDistributionPartnerNumber(basket?.distributionPartners, type)
  },

  hasPartner(basket) {
    return !isDefaultDistribution(basket) && !basket.collective
  },
}

const createDistributionPartner = (distributionPartnerNumber, distributionPartnerType) => {
  return {
    distributionPartnerType,
    distributionPartnerNumber,
  }
}

const isDefaultDistribution = basket => {
  return DistributionUtil.getDistributionPartnerByBasket(basket) === DEFAULT_DISTRIBUTION_PARTNER_NUMBER
}
